import React from "react";
import {Modal} from "antd";

const ShowMessage = ({title, message, show, onClickOk}) => {

        function handleOk() {
            onClickOk()
        }

        return (
            <>
                <Modal
                    title={
                        <>
                            <div
                                style={{
                                    textAlign: "start",
                                    fontSize: "32px",
                                    fontWeight: "normal",
                                    marginBottom: "20px",
                                    color: "red",
                                }}
                            >
                                {title ?? 'Portal'}
                            </div>
                        </>
                    }
                    open={show}
                    onOk={handleOk}
                    cancelButtonProps={{style: {display: 'none'}}}
                    centered
                >
                    <div style={{marginBottom: "10px"}}>
                        {message}
                    </div>
                </Modal>
            </>
        )
    }
;
export default ShowMessage;
